<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Actualizar contraseña:</h1>
      <p class="title-list">
        {{ selectedProfile?.username }} - {{ selectedProfile?.first_name }}
        {{ selectedProfile?.last_name }}
      </p>
    </div>
    <div class="form-body">
      <form [formGroup]="updatePasswordForm" (ngSubmit)="updatePassword()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Contraseña actual</mat-label>
              <input
                type="password"
                matInput
                name="old_password"
                id="old_password"
                required
                formControlName="old_password"
              />
              @if (updatePasswordForm.get('old_password')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nueva contraseña</mat-label>
              <input
                type="password"
                minlength="8"
                matInput
                name="password"
                id="password"
                required
                formControlName="password"
              />
              @if (updatePasswordForm.get('password')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
              @if (updatePasswordForm.get('password')?.hasError('minlength')) {
                <mat-error class="for-text text-danger"
                  >La contraseña debe contener mínimo 8 caracteres.</mat-error
                >
              }
            </mat-form-field>
            <div class="password-mismatch-error-container">
              @if (
                showPassworError &&
                updatePasswordForm.get('password')?.errors?.['passwordStrength'] &&
                updatePasswordForm.get('password')?.touched
              ) {
                <small class="password-mismatch-error">
                  {{ updatePasswordForm.controls['password'].errors?.['passwordStrength'] }}
                </small>
              }
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Confirmar contraseña</mat-label>
              <input
                type="password"
                minlength="8"
                matInput
                name="confirm_password"
                id="confirm_password"
                required
                formControlName="confirm_password"
              />
              @if (updatePasswordForm.get('confirm_password')?.hasError('required')) {
                <mat-error class="for-text text-danger">Campo obligatorio</mat-error>
              }
            </mat-form-field>
            <div class="password-mismatch-error-container">
              @if (showPasswordMatchError && updatePasswordForm.errors?.['notSame']) {
                <small class="password-mismatch-error">
                  Las contraseñas no coinciden. Intentelo de nuevo
                </small>
              }
            </div>
          </div>
        </div>
        <br />
        <button type="submit" class="primary-button" id="guardar">
          <span class="button-content"><mat-icon>save</mat-icon>Guardar</span>
        </button>
        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
